import ConfirmDialog from "../../components/customHelpers/ConfirmDialog";
import Controls from "../../components/controls/Controls";
import Norecords from "../../components/customHelpers/Norecords";
import Loading from "../../components/customHelpers/Loading";

import Layout from "../../components/layout/Layout";
import {
  TableBody,
  TableRow,
  TableCell,
  Typography,
  makeStyles,
} from "@material-ui/core";

import { Grid, Toolbar, InputAdornment } from "@material-ui/core";
import { useEffect, useRef, useState } from "react";

import { FaUserSlash } from "react-icons/fa";
import { AiOutlineSearch } from "react-icons/ai";
import useTable from "../../components/customHelpers/useTable";
import Notify from "../../components/customHelpers/Notify";
import Notification from "../../components/customHelpers/Notification";
import { FiEdit, FiEye } from "react-icons/fi";

import Admin from "../../components/auth/Admin";
import Staff from "../../actions/staff";
import AddOrganization from "../../components/forms/addOrganization";
import Popup from "../../components/customHelpers/Popup";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Paper } from "@mui/material";
import { useHistory, useLocation } from "react-router-dom";
import { Image_API } from "../../config";
import produce from "immer";

const useStyles = makeStyles((theme) => ({
  activated: {
    color: theme.palette.success.main,
    fontWeight: "bold",
  },
  deactivated: {
    color: theme.palette.error.main,
    fontWeight: "bold",
  },
  image: {
    width: "50px",
    height: "50px",
    objectFit: "cover",
  },
}));
const headCells = [
  { id: "name", label: "Name" },
  { id: "email", label: "Email" },
  { id: "phoneNo", label: "Phone" },
  { id: "address", label: "Address" },
  { id: "status", label: "Status" },
  { id: "image", label: "Logo", disableSorting: true },
  { id: "actions", label: "Actions", disableSorting: true },
];
const AdminDetailPage = () => {
  const classes = useStyles();
  const history = useHistory();

  const { NotifyMessage, notify, setNotify } = Notify();
  const { viewStaff, unlinkAdmin } = Staff();
  const [organization, setOrganization] = useState([]);
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [openPopup, setOpenPopup] = useState(false);
  const [edite, setEdit] = useState(false);

  const [values, setValues] = useState({
    loading: false,
    reload: false,
  });
  let location = useLocation();

  const { loading } = values;
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const value = location.pathname.split("/").filter((x) => x)[
    location.pathname.split("/").filter((x) => x).length - 1
  ];
  useEffect(() => {
    getAdminData();
  }, [value]);

  const getAdminData = () => {
    setValues({
      ...values,
      loading: true,
    });
    viewStaff(value).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
        setValues({
          ...values,
          loading: false,
        });
      } else if (data.staf) {
        setValues({
          ...values,
          loading: false,
        });
        const staffList = data.staf.staffOrganizations.map(
          (org) => org.organization
        );

        setOrganization(staffList);
      }
    });
  };

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(organization, headCells, filterFn);

  const handleSearch = (e) => {
    e.target.value = e.target.value.trimLeft();
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        const columns = ["organization_name", "email", "phoneNo", "address"];

        if (target.value == "") return items;
        else {
          return items.filter((x) => {
            return columns.some((column) => {
              return (
                x[column]
                  .toString()
                  .toLowerCase()
                  .indexOf(target.value.toLowerCase()) > -1
              );
            });
          });
        }
      },
    });
  };
  const onDelete = (Id) => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });
    unlinkAdmin(Id,value).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.message) {
        NotifyMessage({
          message: data.message,
          type: "success",
        });
        setOrganization(
          produce(organization, (draft) => {
            const index = organization.findIndex((item) => item.id === Id);
            if (index !== -1) draft.splice(index, 1);
          })
        );
      }
    });
  };

  return (
    <Layout>
      <Admin>
        <div className="card">
          <Typography variant="h6" className="page-header">
            <ArrowBackIcon
              style={{ cursor: "pointer" }}
              onClick={() => {
                history.push("/admin/organization");
              }}
            ></ArrowBackIcon>{" "}
            <span style={{ marginLeft: "6px" }}>Organizations</span>
          </Typography>
          <Toolbar>
            <Controls.Input
              label="Search organization"
              className="searchInput"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <AiOutlineSearch />
                  </InputAdornment>
                ),
              }}
              onChange={handleSearch}
            />
          </Toolbar>

          <Grid container>
            <Grid item xs={12} className="card__body">
              {loading ? (
                <Loading />
              ) : (
                <Paper style={{ overflowX: "auto" }}>
                  <TblContainer>
                    <TblHead />
                    <TableBody>
                      {recordsAfterPagingAndSorting().length > 0 ? (
                        recordsAfterPagingAndSorting().map((item) => (
                          <TableRow key={item.id}>
                            <TableCell>{item.organization_name}</TableCell>
                            <TableCell>{item.email}</TableCell>
                            <TableCell>{item.phoneNo}</TableCell>
                            <TableCell>{item.address}</TableCell>
                            <TableCell
                              className={
                                item.inactive
                                  ? classes.deactivated
                                  : classes.activated
                              }
                            >
                              {item.inactive ? "Deactivated" : "Activated"}
                            </TableCell>{" "}
                            <TableCell>
                              <img
                                className={classes.image}
                                src={`${Image_API}/${item.profilePicture}`}
                                alt={item.organization_name} // Meaningful alt text
                              />
                            </TableCell>
                            <TableCell>
                              <Controls.ActionButton
                                color="secondary"
                                title="Unlink"
                                onClick={() => {
                                  setConfirmDialog({
                                    isOpen: true,
                                    title: "Are you sure to Remove this Organization?",
                                    subTitle: "You can't undo this operation",
                                    onConfirm: () => {
                                      onDelete(item.id);
                                    },
                                  });
                                }}
                              >
                                <FaUserSlash fontSize="medium" />
                              </Controls.ActionButton>

                              <Controls.ActionButton
                                color="primary"
                                title="View Detail"
                                onClick={() => {
                                  history.push(
                                    `/admin/organization/${item.id}`
                                  );
                                }}
                              >
                                <FiEye fontSize="medium" />
                              </Controls.ActionButton>
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <Norecords col={6} />
                      )}
                    </TableBody>
                  </TblContainer>
                  <TblPagination />
                </Paper>
              )}
            </Grid>
          </Grid>

          <ConfirmDialog
            confirmDialog={confirmDialog}
            setConfirmDialog={setConfirmDialog}
          />
          <Notification notify={notify} setNotify={setNotify} />
        </div>
        <Popup
          title="Organization Form"
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
        >
          <AddOrganization
            NotifyMessage={NotifyMessage}
            setOpenPopup={setOpenPopup}
            recordForEdit={recordForEdit}
            setOrganization={setOrganization}
            edite={edite}
          />
        </Popup>
      </Admin>
    </Layout>
  );
};

export default AdminDetailPage;
